import { Component, Input, type OnInit } from '@angular/core'
import {
  Rental,
  Destroyable,
  untilDestroy,
  isSomething,
  ConfirmDialogService,
  SaveForm,
  updateRentalMultiUnitSettings,
  selectRentalById,
} from '@tokeet-frontend/tv3-platform'
import { FormBuilder, FormGroup } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import { BehaviorSubject } from 'rxjs'
import { filter, switchMap } from 'rxjs/operators'

@Component({
  selector: 'app-rental-multi-unit-settings',
  templateUrl: './rental-multi-unit-settings.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class RentalMultiUnitSettingsComponent extends Destroyable implements OnInit {
  _rental: Rental
  @Input() set rental(r: Rental) {
    this._rental = r
    this.mainRentalId$.next(r.id)
  }
  get rental() {
    return this._rental
  }

  form = this.fb.group({
    auto_assign: ['created'],
    days: [0],
    auto_compact: [false],
  })

  mainRentalId$ = new BehaviorSubject<string>(null)

  constructor(private fb: FormBuilder, private store: Store<any>, private confirm: ConfirmDialogService) {
    super()
  }

  ngOnInit(): void {
    this.mainRentalId$
      .pipe(
        filter(isSomething),
        switchMap((id) => this.store.pipe(select(selectRentalById(id)))),
        untilDestroy(this)
      )
      .subscribe((rental) => {
        this.form.patchValue({
          auto_assign: 'created',
          days: 0,
          auto_compact: false,
          ...(rental?.multi_unit_settings || {}),
        })
      })
  }

  save() {
    this.onSave(this.form)
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const payload = this.form.getRawValue()

    this.store.dispatch(updateRentalMultiUnitSettings({ rentalId: this.rental.id, settings: payload }))
  }

  onAutoCompactToggle(enabled: boolean) {
    if (!enabled) {
      this.saveAutoCompact(false)
      return
    }

    this.form.patchValue({ auto_compact: false })
    this.confirm
      .confirm({
        title: $localize`Automatic compaction`,
        body: $localize`This action will Automatically rearrange bookings across units. Do you want to proceed?`,
        confirmText: $localize`Yes, proceed`,
        cancelText: $localize`NO, May be not`,
      })
      .subscribe(() => this.saveAutoCompact(true))
  }

  private saveAutoCompact(enabled: boolean) {
    this.form.patchValue({ auto_compact: enabled })
    const payload = this.form.getRawValue()

    this.store.dispatch(updateRentalMultiUnitSettings({ rentalId: this.rental.id, settings: payload }))
  }
}
